// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1HWXi","title":"Images90_title__-3cfl","images":"Images90_images__I6kJQ"};